import React from "react";
import "./ServiceSection.scss"; // Import your stylesheet
import LearnMoreButton from "../../components/LearnMoreButton/LearnMoreButton";

const ServiceSection = ({ title, description, subtitle, buttonLabel, link }) => {
  return (
    <section className="service-section">
          <h6>{subtitle}</h6>
          <h1>{title}</h1>
          <h5>{description}</h5>
          {buttonLabel && link && (
           <div className="service-section__button">
            <LearnMoreButton
              label={buttonLabel}
              href={link}
              variant="default"
            />
            </div>
          )}
    </section>
  );
};

export default ServiceSection;
